import axios from "axios";
import {
  appendAuthInterceptor,
  requestWrapper,
} from "../../../../Common/serviceFactory";

import presitentStore from "../../../../store";
import { reportingAsSelector } from "../../../../store/applicantsSlice";

const { store } = presitentStore;
const axiosFilesInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_APPLICANTS_FILES}`,
});

const appendAsHeader = async (config) => {
  const reportingAs = reportingAsSelector(store.getState());
  if (!!reportingAs) config.headers["X-REPORTING-AS"] = reportingAs;
  return config;
};
const PROPOSAL_FILES_BASE_URL = "registration/Proposal docs";
const APPLICANTS_FILES_BASE_URL = "registration/Applicants docs";

axiosFilesInstance.interceptors.request.use(appendAsHeader);

appendAuthInterceptor(axiosFilesInstance);

export async function UploadProposalFile(props) {
  const { file, proposalId, fileName } = props;
  var formData = new FormData();
  formData.append("document1", file);
  return await requestWrapper(
    axiosFilesInstance.post(
      `files/?path=${PROPOSAL_FILES_BASE_URL}/${proposalId}/${proposalId}_${fileName}.pdf`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    )
  );
}

export async function UploasApplicantFile(props) {
  const { file, applicantId, fileName } = props;
  var formData = new FormData();
  formData.append("document1", file);
  return await requestWrapper(
    axiosFilesInstance.post(
      `files/?path=${APPLICANTS_FILES_BASE_URL}/${applicantId}/${applicantId}_${fileName}.pdf`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    )
  );
}

export async function getProposalFiles(props) {
  const { proposalId } = props;
  return await requestWrapper(
    axiosFilesInstance.get(
      `files/?path=${PROPOSAL_FILES_BASE_URL}/${proposalId}`
    )
  );
}
export async function getApplicantsFiles(props) {
  const { applicantId } = props;
  return await requestWrapper(
    axiosFilesInstance.get(
      `files/?path=${APPLICANTS_FILES_BASE_URL}/${applicantId}`
    )
  );
}

export async function downloadProposalFiles(props) {
  const { id, fileName } = props;
  const filePath = `files/${PROPOSAL_FILES_BASE_URL}/${id}/${id}_${fileName}`;
  return await requestWrapper(
    axiosFilesInstance.get(filePath, {
      params: {
        cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
      },
      responseType: "blob",
      headers: {
        Accept: "application/octet-stream",
      },
    })
  );
}

export async function downloadApplicantFiles(props) {
  const { id, fileName } = props;
  const filePath = `files/${APPLICANTS_FILES_BASE_URL}/${id}/${id}_${fileName}`;
  return await requestWrapper(
    axiosFilesInstance.get(filePath, {
      params: {
        cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
      },
      responseType: "blob",
      headers: {
        Accept: "application/octet-stream",
      },
    })
  );
}

export async function deleteProposalFile(props) {
  const { id, fileName } = props;
  const filePath = `files/${PROPOSAL_FILES_BASE_URL}/${id}/${id}_${fileName}`;
  return await requestWrapper(axiosFilesInstance.delete(filePath));
}

export async function deleteApplicantFile(props) {
  const { id, fileName } = props;
  const filePath = `files/${APPLICANTS_FILES_BASE_URL}/${id}/${id}_${fileName}`;
  return await requestWrapper(axiosFilesInstance.delete(filePath));
}

export async function downloadRawFile({ path, filename }) {
  const response = await requestWrapper(
    axiosFilesInstance.get(`files/${path}`, {
      params: {
        cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
      },
      responseType: "blob",
      headers: {
        Accept: "application/octet-stream",
      },
    })
  );

  if (!(response instanceof Blob)) {
    return;
  }

  const blob = new Blob([response], { type: "application/pdf" });
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl);
}
